<template>

  <div class="flex flex-col lg:flex-row">

    <div class="flex-auto">

      <h1 class="py-8 mb-4">Summary</h1>

      <VaCart title="" :data="cart">

        <template slot="footer">

          <div class="p-2">
            <!-- <h4 class="basket-heading-section mb-8">Add an Area</h4> -->
            <AddAreaButtons class="flex flex-col sm:flex-row sm:flex-wrap" />
          </div>

          <div class="divider-border"></div>

          <div class="px-2 py-4 text-center sm:text-left">

            <NewProjectButton />

          </div>

        </template>

      </VaCart>

    </div>

    <div class="w-full lg:w-400px lg:min-w-400px lg:max-w-400px ml-0 lg:ml-10">

      <EmailSummary :shadow="false" class="mt-10 sm:mb-16 sm:p-8 sm:shadow-lg" />

    </div>

  </div>

</template>

<script>

import VaCart from '@/components/VaCart.vue'

import AddAreaButtons from '@/components/AddAreaButtons.vue'

import NewProjectButton from '@/components/NewProjectButton.vue'

import EmailSummary from '@/components/EmailSummary.vue'

import { mapState, mapActions } from 'vuex'

export default {

  name: 'VaSummary',

  components: {
    VaCart,
    AddAreaButtons,
    NewProjectButton,
    EmailSummary
  },

  props: {

    data: { type: Object }

  },

  computed: {

    ...mapState(['cart'])

  }

}
</script>
